import React, { useCallback, useContext, useEffect } from 'react'

import {
  getPopupWrapperDom,
  // theme,
  TogetherAuthConfigContextProvider,
  TogetherComponentGlobalContextProvider,
} from '@hhgtech/hhg-components'
import { ArticlePageContext } from 'components/pages/article'
import { DEFAULT_LOCALE, ENV } from 'interfaces/constants'
// import { Article } from 'interfaces/types'
import { useRouter } from 'next/router'
import { createPortal } from 'react-dom'
import { AppContext } from 'state/appContext'
// import { CSSProperties } from 'styled-components'
import { sanitize } from 'utils/togetherPost'

import { TogetherDataContextProvider } from '../common/TogetherDataWrapper'
import { getPostListsByArticleId } from '../common/TogetherDataWrapper/api/services'
import { formatPost } from '../utils/dataTransform'
import { StyledWrapper } from './index.styled'

// export type Props = {
//   article?: Article
//   isCommentPopupOpen?: boolean
//   style?: CSSProperties
//   children: ReactNode
// }

const PopupWrapper = ({
  article,
  isCommentPopupOpen,
  children,
  setPostCount,
  ...rest
}: any) => {
  const { state, pushNotifications } = useContext(AppContext)
  const { userInfo, isLoggedIn } = state
  const router = useRouter()
  const { locale = DEFAULT_LOCALE as any } = router
  const { currentArticle } = useContext(ArticlePageContext)
  const isCurrentPopupOpen =
    isCommentPopupOpen && currentArticle?.id === article?.id

  const fetchPosts = useCallback(
    async (id: string, sortBy = 'newest') => {
      try {
        const res = await getPostListsByArticleId(id, sortBy, isLoggedIn)
        setPostCount((res?.data?.posts || []).map(formatPost).length || 0)
      } catch {}
    },
    [isLoggedIn],
  )

  useEffect(() => {
    currentArticle?.id === article?.id && fetchPosts(article?.id)
  }, [currentArticle, article])

  return (
    isCurrentPopupOpen &&
    createPortal(
      <TogetherComponentGlobalContextProvider
        userInfo={userInfo || undefined}
        locale={locale}
        router={router}
        pushNotifications={pushNotifications}
        sanitizeFunction={sanitize}
        env={{
          isMarryBaby: true,
          togetherBasePath: '/community',
          publicSSO: ENV.NEXT_PUBLIC_SSO,
          togetherBaseApiUrl: ENV.NEXT_PUBLIC_TOGETHER_API,
          discoverBaseApiUrl: ENV.NEXT_PUBLIC_DISCOVER_BASE_API_URL,
          discoverBaseProdApiUrl: ENV.NEXT_PUBLIC_DISCOVER_BASE_PROD_API_URL,
          marryBabyApiUrl: ENV.NEXT_PUBLIC_BASE_API_URL,
          marryBabyProdApiUrl: ENV.NEXT_PUBLIC_BASE_PROD_API_URL,
          careBaseApiUrl: ENV.NEXT_PUBLIC_CARE_API,
        }}
      >
        <TogetherAuthConfigContextProvider
          defaultParams={{
            action: 'comment',
          }}
        >
          <TogetherDataContextProvider>
            <StyledWrapper className="askdoctor-popup" {...rest}>
              {children}
            </StyledWrapper>
          </TogetherDataContextProvider>
        </TogetherAuthConfigContextProvider>
      </TogetherComponentGlobalContextProvider>,
      getPopupWrapperDom(),
    )
  )
}

export { PopupWrapper }
